import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [progress, setProgress] = useState(null);

  const loadProgress = async () => {
    try {
      const { data } = await api.get("/progress");
      setProgress(data);
    } catch (e) {
      setProgress(null);
    }
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      return data.user;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
        loadProgress();
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ta_token", data.token);
    setUser(data.user);
    loadProgress();
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("ta_token", data.token);
    setUser(data.user);
    loadProgress();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ta_token");
    setUser(false);
    setProgress(null);
  };

  return (
    <AuthContext.Provider value={{ user, progress, setUser, setProgress, loadProgress, refreshUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
